import { fetchProviderProductDetail } from "@/api/providerDashboard";
import {
  buildPreferenceWeights,
  normalizeProductPreferences,
} from "@/utils/productPreferences";

export default {
  async loadProduct() {
    this.loading = true;
    try {
      const res = await fetchProviderProductDetail(this.$route.params.id);
      if (res.data.status === 200) {
        const data = res.data.data;
        const preferences = normalizeProductPreferences(data.preferences || []);
        this.form = {
          name: data.name || "",
          description: data.description || "",
          imagesUrls: data.imagesUrls || [],
          stoneSize: data.stoneSize || "",
          preferences,
          preferenceWeights: buildPreferenceWeights(
            preferences,
            data.preferenceWeights
          ),
          sortOrder: data.sortOrder || 0,
          price: Number(data.price) || 0,
          quoteOnly: !!data.quoteOnly,
        };
      }
    } catch (err) {
      this.$message.error("상품 정보를 불러올 수 없습니다.");
    } finally {
      this.loading = false;
    }
  },
};
